import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PolicyDocument from '../components/PolicyDocument';
import { FileText } from 'lucide-react';

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      {/* Ambient Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-to-br from-gray-800/20 via-gray-700/10 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-to-tr from-black via-gray-900/50 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-gradient-to-br from-gray-900/10 to-gray-800/10 rounded-full blur-3xl animate-pulse"></div>
      </div>

      <Navigation />

      {/* Main Content */}
      <div className="relative z-10">
        <section className="relative py-28">
          <div className="max-w-5xl mx-auto px-8">
            {/* Header */}
            <div className="text-center mb-12">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#AD0000] to-red-700 rounded-2xl mb-6 shadow-xl">
                <FileText className="w-10 h-10 text-white" />
              </div>
              <h1 className="text-5xl lg:text-6xl font-black mb-4">
                Terms & <span className="text-white">Conditions</span>
              </h1>
            </div>

            {/* Content — the document itself is stored in the database and served by
                /api/settings/policy/terms, so it can be revised without a deploy and cannot
                drift away from what the signup consent modal shows. */}
            <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-10 md:p-12 border border-white/10">
              <PolicyDocument type="terms" />
            </div>
          </div>
        </section>
      </div>

      <Footer />

      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default Terms;
